module.exports = __webpack_public_path__ + "img/c5-m.bbf68e0c.jpg";